import { AccountGroup } from '@galaxy/account-group';

export class ProductAccount {
  account_id: string;
  is_trial: boolean;
  marketplace_app_id: string;
  product_id: string;

  constructor(data: any) {
    Object.assign(this, data);
  }
}

export class Account {
  account_group_id: string;
  company_name: string;
  address: string;
  address2: string;
  city: string;
  state: string;
  country: string;
  zip: string;
  work_number: string;
  call_tracking_number: string;
  website: string;
  partner_id: string;
  market_id: string;
  customer_identifier: string;
  tax_ids: string[];
  vcategory_ids: string[];
  sales_person_id: string;
  snapshot_listing_scan_url: string;
  admin_notes: string;
  tags: string[];
  action_lists: string[];
  additional_sales_person_ids: string[];
  timezone: string;
  created: string;
  updated: string;

  constructor(data: any) {
    Object.keys(data).map((property) => {
      this[property] = data[property];
    });
  }

  get fullAddress(): string {
    const parts = [this.address, this.city, this.state, this.country, this.zip].filter((part) => !!part);
    return parts.join(', ');
  }

  static AccountFromAccountGroup(accountGroup: AccountGroup, sscDomain: string): Account {
    if (!accountGroup?.accountGroupId) {
      return null;
    }
    return new Account({
      account_group_id: accountGroup.accountGroupId,
      company_name: accountGroup.napData.companyName,
      address: accountGroup.napData.address,
      address2: accountGroup.napData.address2,
      city: accountGroup.napData.city,
      state: accountGroup.napData.state,
      country: accountGroup.napData.country,
      zip: accountGroup.napData.zip,
      work_number: accountGroup.napData.workNumber,
      call_tracking_number: accountGroup.napData.callTrackingNumber,
      website: accountGroup.napData.website,
      partner_id: accountGroup.externalIdentifiers.partnerId,
      market_id: accountGroup.externalIdentifiers.marketId,
      customer_identifier: accountGroup.externalIdentifiers.customerIdentifier,
      tax_ids: accountGroup.externalIdentifiers.taxIds,
      vcategory_ids: accountGroup.externalIdentifiers.vCategoryIds,
      sales_person_id: accountGroup.externalIdentifiers.salesPersonId,
      snapshot_listing_scan_url: `https://${sscDomain}/snapshot/lite/${accountGroup.accountGroupId}`,
      admin_notes: accountGroup.legacyProductDetails?.adminNotes ?? '',
      tags: accountGroup.externalIdentifiers.tags,
      action_lists: accountGroup.externalIdentifiers.actionLists,
      additional_sales_person_ids: accountGroup.externalIdentifiers.additionalSalesPersonIds,
      timezone: accountGroup.napData.timezone,
      created: accountGroup.created,
      updated: accountGroup.updated,
    });
  }
}
